'use strict';
var fragt = fragt || {};

fragt.newsListView = fragt.newsListView || new function () {
    var self = this;

    var pageCounterEl = "";
    var dataPageVal = "";
    if (document.getElementById('page-counter') != null) {
        pageCounterEl = document.getElementById('page-counter');
        dataPageVal = pageCounterEl.getAttribute('data-page');
    }

    var page = parseInt(dataPageVal);

    if (isNaN(page) || page === "" || page == null || !page || isNaN(page.toString())) {
        page = 0;
    }

    this.init = function () {
        if (document.getElementById('newsListView') != null) {
            if (document.getElementById('newsListView').children) {
                self.loader();
                self.bindEvents();
                self.loadNews(page, false);
            }
        }
    };

    this.loader = function () {
        document.getElementById('newsListView').innerHTML = '<li class="loader"><div id="fountainTextG"><div id="fountainTextG_1" class="fountainTextG">f</div><div id="fountainTextG_2" class="fountainTextG">r</div><div id="fountainTextG_3" class="fountainTextG">a</div><div id="fountainTextG_4" class="fountainTextG">g</div><div id="fountainTextG_5" class="fountainTextG">t</div></div></li>';
        //$('.loader').fadeIn();
    };

    this.bindEvents = function() {
        document.querySelector('#nextPageBtn').addEventListener('click', self.loadMore);
    };

    this.loadMore = function () {
        var currentPage = parseInt(document.querySelector('#page-counter').getAttribute('data-page'));
        document.querySelector('#page-counter').setAttribute('data-page', currentPage + 1);

        self.loadNews(currentPage + 1, true);
    };

    this.loadNews = function (page, loadingMore) {

        if(!loadingMore) {
            this.nlEle = document.querySelector('#newsListView');
            this.nodeId = this.nlEle.getAttribute('data-nodeid');
            this.ipp = this.nlEle.getAttribute('data-ipp'); // Items Per Page
            this.queryYear = this.nlEle.getAttribute('data-year');
            this.queryMonth = this.nlEle.getAttribute('data-month');
        }


        var filterValues = JSON.stringify({
            'NodeId': this.nodeId, // Int
            'NumberOfItemsPerPage': this.ipp, // Int
            'Page': page, // Int
            'MonthNumber': this.queryMonth, //Int or null
            'YearNumber': this.queryYear, //Int or null
        });

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/settings/newslistview/', true);
        xhr.setRequestHeader('content-type', 'html/text; charset=utf-8');
        xhr.ResponseType = 'document';
        xhr.onload = function () {
            if (xhr.readyState === 4) {
                if (xhr.status === 200 || xhr.status === 404) {
                    var nextPageBtn = document.querySelector('#nextPageBtn');

                    if (xhr.status === 200) {
                        var parser = new DOMParser();
                        var doc = parser.parseFromString(xhr.responseText, "text/html");
                        if (page > 0) {
                            document.querySelector('#newsListView').insertAdjacentHTML('beforeend', xhr.responseText);
                        } else {
                            document.querySelector('#newsListView').innerHTML = xhr.responseText;
                            document.getElementById('page-counter').setAttribute('data-page', 0);
                        }
                        self.hasNextPage = doc.querySelector('.hasNextPage').value;
                        if (self.hasNextPage === 'False') {
                            nextPageBtn.style.display = 'none';
                        } else {
                            nextPageBtn.style.display = '';
                        }
                        if(!loadingMore) {
                            fragt.filter.init();
                        } else {
                            fragt.filter.init(true);
                        }
                    }
                    if (xhr.status === 404) {
                        nextPageBtn.style.display = 'none';
                        document.querySelector('#newsListView').innerHTML =
                            '<div class="ajax-content error-msg">Der er desv&aelig;rre sket en fejl </br></br>' +
                            xhr.status +
                            ' ' +
                            xhr.statusText +
                            '</br ></br > <button class="btn btn-blue light" onclick="location.reload();"> Genindl&aelig;s siden </button></div >';
                    }
                } else {
                    console.log(xhr.responseText);
                }
            }
        };
        xhr.onerror = function () {
            var nextPageBtn = document.querySelector('#nextPageBtn');
            nextPageBtn.style.display = 'none';
            document.querySelector('#newsListView').innerHTML =
                '<div class="ajax-content error-msg">Der er desv&aelig;rre sket en fejl </br></br>' +
                xhr.status +
                ' ' +
                xhr.statusText +
                '</br ></br > <button class="btn btn-blue light" onclick="location.reload();"> Genindl&aelig;s siden </button></div >';
        };
        xhr.send(filterValues);
    };
}();
